export interface IUiRuntimeConfig {
  api_url: string;
  group_for_hpc_project_claim: string;
  nexus_gxp_upload_disable: string;
  enable_file_preview: string;
  default_experiment_retention_period: string;
  analytics_on_hpc_filter_option: string;
  secret_key_for_api: string;
}

export let GROUP_FOR_HPC_PROJECT_CLAIM: string | undefined;
export let NEXUS_GXP_UPLOAD_DISABLE = false;
export let ENABLE_FILE_PREVIEW = false;
export let RETENTION_DEFAULT_EXPERIMENT: string | undefined;
export let ANALYTICS_ON_HPC_FILTER_OPTION: string | undefined;
export let SECRET_KEY_FOR_API: string | undefined;

const parseBoolean = (value: string): boolean => value.toLowerCase() === "true";

export const applyUiRuntimeConfig = (config: IUiRuntimeConfig): void => {
  if (
    !config.api_url ||
    !config.secret_key_for_api ||
    typeof config.group_for_hpc_project_claim !== "string" ||
    typeof config.nexus_gxp_upload_disable !== "string" ||
    typeof config.enable_file_preview !== "string" ||
    typeof config.default_experiment_retention_period !== "string" ||
    typeof config.analytics_on_hpc_filter_option !== "string"
  ) {
    throw new Error("UI secrets response is missing required runtime settings");
  }

  GROUP_FOR_HPC_PROJECT_CLAIM = config.group_for_hpc_project_claim;
  NEXUS_GXP_UPLOAD_DISABLE = parseBoolean(config.nexus_gxp_upload_disable);
  ENABLE_FILE_PREVIEW = parseBoolean(config.enable_file_preview);
  RETENTION_DEFAULT_EXPERIMENT = config.default_experiment_retention_period.toLowerCase();
  ANALYTICS_ON_HPC_FILTER_OPTION = config.analytics_on_hpc_filter_option.toLowerCase();
  SECRET_KEY_FOR_API = config.secret_key_for_api;
};

export const resetUiRuntimeConfig = (): void => {
  GROUP_FOR_HPC_PROJECT_CLAIM = undefined;
  NEXUS_GXP_UPLOAD_DISABLE = false;
  ENABLE_FILE_PREVIEW = false;
  RETENTION_DEFAULT_EXPERIMENT = undefined;
  ANALYTICS_ON_HPC_FILTER_OPTION = undefined;
  SECRET_KEY_FOR_API = undefined;
};